import styled from 'styled-components';

export const LayoutContainer = styled.div`
	.sidebarlist-item-icon {
		width: 24px;
		height: 24px;
	}
`;
